var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 93.41 171.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);}.cls-12,.cls-14,.cls-2,.cls-26,.cls-28,.cls-4{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{mask:url(#mask-2);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{isolation:isolate;}.cls-6{fill:#d9b58b;}.cls-19,.cls-7{fill:#fff;mix-blend-mode:soft-light;}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:#95612a;}.cls-10{fill:url(#linear-gradient-4);}.cls-11{mask:url(#mask-3);}.cls-12,.cls-14,.cls-15,.cls-25{opacity:0.3;}.cls-12{fill:url(#linear-gradient-5);}.cls-13{mask:url(#mask-4);}.cls-14{fill:url(#linear-gradient-6);}.cls-15,.cls-18{fill:#505050;}.cls-15,.cls-17,.cls-18,.cls-25{mix-blend-mode:color-burn;}.cls-16{fill:#70491f;}.cls-17{fill:gray;}.cls-17,.cls-18,.cls-21{opacity:0.2;}.cls-19{opacity:0.4;}.cls-20{opacity:0.21;}.cls-22{fill:url(#linear-gradient-7);}.cls-23{fill:#e6e6e6;}.cls-24{fill:#a3472b;}.cls-25{fill:#6a6a6a;}.cls-26,.cls-28{opacity:0.5;}.cls-26{fill:url(#linear-gradient-8);}.cls-27{fill:url(#linear-gradient-9);}.cls-28{fill:url(#linear-gradient-10);}.cls-29{filter:url(#luminosity-noclip-4);}.cls-30{filter:url(#luminosity-noclip-3);}.cls-31{filter:url(#luminosity-noclip-2);}.cls-32{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 3238.9,
    y: -8417,
    width: 71.04,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 3238.9,
    y: -8417,
    width: 71.04,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3246.91,
    y1: 219.79,
    x2: 3301.64,
    y2: 175.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 3238.9,
    y: -8417,
    width: 71.05,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 3238.9,
    y: -8417,
    width: 71.05,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3277.86,
    y1: 162.1,
    x2: 3270.97,
    y2: 232.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 87.13,
    y1: 99.85,
    x2: 6.82,
    y2: 150.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a46d2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0925c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3271.94,
    y1: 219.85,
    x2: 3278.1,
    y2: 164.39,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 3238.9,
    y: 161.93,
    width: 71.04,
    height: 71.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 13.25,
    y: 89.23,
    width: 71.04,
    height: 71.05,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3225.65 -72.7)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3274.42,233A35.52,35.52,0,1,1,3310,197.45,35.56,35.56,0,0,1,3274.42,233Z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 3246.91,
    y1: 219.79,
    x2: 3301.64,
    y2: 175.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 3238.9,
    y: 161.93,
    width: 71.05,
    height: 71.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 13.25,
    y: 89.23,
    width: 71.05,
    height: 71.04,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3225.65 -72.7)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3310,197.46a35.53,35.53,0,0,1-68.14,14.08,35.19,35.19,0,0,1-2.91-14.08,35.53,35.53,0,0,1,71,0Z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 3277.86,
    y1: 162.1,
    x2: 3270.97,
    y2: 232.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 58.21,
    y1: 79.09,
    x2: -18.79,
    y2: -59.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 103.25,
    y1: -32.69,
    x2: 38.55,
    y2: 67.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#acacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#cacaca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 46.89,
    y1: 42.86,
    x2: 84.33,
    y2: 42.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 111.41,
    y1: -32.4,
    x2: 46.45,
    y2: 67.92,
    xlinkHref: "#linear-gradient-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "84.3 138.48 89.06 145.27 87.44 145.91 79.42 147.61 79.18 147.66 78.97 147.7 77.78 147.95 78.11 149.01 79.91 154.73 80.65 157.1 79.03 157.74 78.09 157.64 70.68 156.85 69.43 156.72 69.21 156.7 69.21 156.88 69.16 158.86 68.98 165.75 67.36 166.39 59.37 162.8 58.37 162.36 55.22 170.38 53.61 171.01 46.76 164.83 46.28 164.4 40.71 170.52 39.09 171.16 34.22 162.7 34.17 162.6 26.85 166.17 25.23 166.81 23.2 157.14 13.6 158.37 13.41 158.39 14.41 148.93 14.46 148.58 4.76 146.74 4.87 146.49 8.79 137.71 8.63 137.64 0.14 132.97 6.76 125.64 6.53 125.41 0 118.45 0.22 118.31 8.54 113.53 8.38 113.17 4.33 104.61 5.95 103.95 13.04 102.73 14 102.56 13.96 102.27 12.76 92.78 13.08 92.65 14.37 92.14 18.08 92.9 22.58 93.82 22.73 93.03 22.99 91.72 24.43 84.12 26.03 83.48 33.43 88.15 34.03 87.05 38.18 79.49 39.79 78.86 45.51 86.12 46.65 85.05 52.69 79.35 54.31 78.71 57.55 87.71 57.63 87.92 57.89 87.8 59.21 87.22 61.13 86.38 66.46 84.03 68.3 92.09 68.59 93.36 70.02 93.18 78.38 92.13 77.55 99.86 77.33 101.93 79.54 102.35 87.04 103.78 84.05 110.43 83 112.79 85.3 114.05 91.65 117.55 86.78 122.93 85.03 124.86 86.78 126.72 91.79 132.07 85.19 135.85 83.24 136.97 84.3 138.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3248.35,220.09l-6.54,9.48-2.56,1.49-.19,0,1-9.45,3-1.67-9.94-1.87-2.58,1.1,3.92-8.78-.15-.08,2.77-.87-8.36-4.76-2.91,1,6.62-7.32-.22-.23,2.86-.79.59-2.6-7.19-4.41-2.58.7,8.33-4.79-.17-.35,2.33-.71s4.78,8.46,4.53,8.79S3248.35,220.09,3248.35,220.09Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "79.4 147.37 79.42 147.61 79.52 148.25 80.41 155.23 80.65 157.1 77.18 156.74 70.83 156.05 70.68 156.85 70.12 159.82 68.98 165.75 59.97 161.72 59.37 162.8 55.22 170.38 47.9 163.76 46.76 164.83 40.71 170.52 35.79 161.96 34.22 162.7 26.85 166.17 24.82 156.51 15.02 157.75 15.04 157.53 16.05 148.02 16.06 147.94 6.37 146.09 6.51 145.78 10.34 137.22 10.4 137.08 10.26 137 1.86 132.4 1.75 132.34 8.19 125.19 8.36 125 8.17 124.81 1.7 117.92 1.61 117.81 9.84 113.07 10.16 112.88 10.06 112.66 9.99 112.55 6.67 105.46 6.53 105.19 5.95 103.95 12.81 102.51 13.96 102.27 15.09 102.03 15.61 101.92 15.54 101.38 15.5 101.06 14.62 94.19 14.51 93.3 14.37 92.14 17.67 92.5 19.99 92.74 22.73 93.03 23.77 93.13 24.18 93.18 24.22 92.95 24.26 92.79 26.03 83.48 34.03 87.05 35.05 87.51 39.79 78.86 46.65 85.05 47.12 85.47 54.31 78.71 59.21 87.22 59.23 87.27 61.13 86.38 68.16 83.07 70.2 92.72 80 91.49 78.95 101.3 88.63 103.14 84.67 112.05 84.61 112.15 84.72 112.22 93.26 116.91 86.82 124.03 86.64 124.23 86.83 124.42 93.41 131.42 85.09 136.22 84.84 136.35 84.96 136.59 89.06 145.27 79.45 147.3 79.44 147.3 79.4 147.31 79.4 147.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M3309,197.56a39.84,39.84,0,0,1-3.73,17.12c-.19.42-.39.82-.61,1.23s-.49.93-.76,1.38l-.07.11c-.22.4-.46.78-.7,1.16s-.47.73-.72,1.09c-.52.77-1.08,1.52-1.67,2.23-.22.27-.44.55-.68.81a33.67,33.67,0,0,1-5.6,5.2c-.26.2-.53.38-.8.58a36.62,36.62,0,0,1-21,6.36,40.44,40.44,0,0,1-11-1.51l-.2-.06A38,38,0,0,1,3236,209.92a2,2,0,0,1-.08-.22,36.37,36.37,0,0,1-2.07-11.8c0-.12,0-.26,0-.39v-.08a41,41,0,0,1,1.67-11.67c0-.17.1-.34.15-.51a38.37,38.37,0,0,1,1.41-3.85c.09-.2.17-.41.27-.61s.14-.3.21-.46c.28-.62.59-1.22.9-1.83a33.64,33.64,0,0,1,2.31-3.77c.14-.22.29-.44.44-.65l0,0,.18-.22a29,29,0,0,1,1.95-2.47c.3-.34.59-.66.89-1h0l.4-.42c.44-.46.9-.9,1.36-1.33s.69-.63,1-.93c.75-.64,1.52-1.26,2.32-1.83l.05,0c.16-.12.32-.24.49-.35a35.92,35.92,0,0,1,14-5.86v0a50.69,50.69,0,0,1,12.73-.09,18,18,0,0,1,5.8,1.77,1.88,1.88,0,0,0,1.64.1A38.33,38.33,0,0,1,3300.25,173l.07.08.46.57a.05.05,0,0,1,0,0h0a39.05,39.05,0,0,1,5.48,9.57h0A38.92,38.92,0,0,1,3309,197.56Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3312.47,196.73q0-.55,0-1.11a36.57,36.57,0,0,0-1.48-8.87c-.18-.63-.37-1.24-.59-1.84a1,1,0,0,0,0-.16c-.19-.55-.4-1.09-.61-1.62a37.61,37.61,0,0,0-4.52-8.08,31.45,31.45,0,0,0-2-2.49,37.76,37.76,0,0,0-7.53-6.68c-.56-.38-1.13-.75-1.72-1.1a37,37,0,0,0-10.4-4.28l-.35-.09-.61-.14a49.26,49.26,0,0,0-6-.78,34.11,34.11,0,0,0-11.39,1v.06a37.69,37.69,0,0,0-13.86,6.66,2.26,2.26,0,0,0-.31.23,30.53,30.53,0,0,0-3,2.57c-.1.08-.19.18-.29.27-.71.69-1.39,1.41-2,2.15l-.56.65a37.39,37.39,0,0,0-3.68,5.24c-.38.67-.75,1.33-1.1,2h0a38.85,38.85,0,0,0-2.77,7.2c-.07.33-.16.66-.24,1a38.23,38.23,0,0,0-1.06,9,38.16,38.16,0,0,0,25.1,35.8,1.08,1.08,0,0,0,.18.07,38.33,38.33,0,0,0,12.78,2.2,37.89,37.89,0,0,0,19.17-5.19c.42-.24.84-.5,1.25-.75,0,0,0,0,0,0h0l.21-.15a32.45,32.45,0,0,0,4.4-3.34,28,28,0,0,0,2.11-2h0a2.27,2.27,0,0,0,.3-.32,27.81,27.81,0,0,0,1.87-2.06c.12-.16.24-.31.37-.46l.58-.75c0-.06.08-.09.12-.15s.14-.19.21-.29h0a.1.1,0,0,0,0-.05c.55-.73,1.06-1.49,1.56-2.27a37.91,37.91,0,0,0,3.3-6.55c.23-.63.46-1.25.66-1.89a3.19,3.19,0,0,1,.13-.37,2.54,2.54,0,0,0,.1-.37,37.71,37.71,0,0,0,1.6-9.13c0-.65,0-1.3,0-2v-.35A2.42,2.42,0,0,0,3312.47,196.73Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3274.42,233A35.52,35.52,0,1,1,3310,197.45,35.56,35.56,0,0,1,3274.42,233Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3274.42,233A35.52,35.52,0,1,1,3310,197.45,35.56,35.56,0,0,1,3274.42,233Z",
    transform: "translate(-3225.65 -72.7)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M3310,197.46a35.53,35.53,0,0,1-68.14,14.08,35.19,35.19,0,0,1-2.91-14.08,35.53,35.53,0,0,1,71,0Z",
    transform: "translate(-3225.65 -72.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M3310,197.45a35.57,35.57,0,0,1-34,35.49c18.15-1.56,31.66-16.83,31.66-35.38,0-19.59-15.16-35.52-34.75-35.52-.54,0-1.07,0-1.61,0,1.06-.09,2.12-.14,3.2-.14A35.56,35.56,0,0,1,3310,197.45Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3303.34,212.85s-1,2.51-2.39,3.19a3.49,3.49,0,0,1-1.86.39h0a1.4,1.4,0,0,1-1.25-.84c-.34-.94.49-2.26,1.87-2.94a2.74,2.74,0,0,1,1-.25A7.06,7.06,0,0,1,3303.34,212.85Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3296,215a1,1,0,0,1-.9.18,3.55,3.55,0,0,1-2-1.68,8,8,0,0,1-.62-4c0-.11,0-.17,0-.17a6.06,6.06,0,0,1,3.18,2C3296.57,212.74,3296.7,214.37,3296,215Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3299.61,219.44s-1.37,2.26-2.82,2.66a3.72,3.72,0,0,1-1.26.12,1.73,1.73,0,0,1-1.73-1.21c-.21-1,.82-2.11,2.27-2.5a2,2,0,0,1,.34-.06A6.19,6.19,0,0,1,3299.61,219.44Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3291.44,220.31a.92.92,0,0,1-.49,0,3.43,3.43,0,0,1-1.66-2.64,7.56,7.56,0,0,1,.65-3.77,3.76,3.76,0,0,1,.15-.36,7.22,7.22,0,0,1,2.28,3.29C3292.71,218.51,3292.3,220.07,3291.44,220.31Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3306.1,204.28s-.6,2.67-1.85,3.63a3.19,3.19,0,0,1-2.25.77,1.16,1.16,0,0,1-.88-.57c-.48-.85.14-2.32,1.39-3.28a3.89,3.89,0,0,1,2.15-.63h0A7.74,7.74,0,0,1,3306.1,204.28Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3299.63,208.05a1.27,1.27,0,0,1-1.35.5,3.52,3.52,0,0,1-1.77-.85c-1.21-1-1.73-3.72-1.73-3.72l.46,0h.09a4.67,4.67,0,0,1,3,.76C3299.57,205.72,3300.14,207.22,3299.63,208.05Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3303,190.19c-.54,1.52-1.59,2.48-2.38,2.24h0l-.12-.05c-.81-.4-1-2-.41-3.62a6,6,0,0,1,2.27-2.5c.28-.19.46-.29.46-.29S3303.63,188.59,3303,190.19Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3299.4,193.11a1.6,1.6,0,0,1-1.78.84,3.74,3.74,0,0,1-1.33-.38c-1.37-.68-2.39-3.18-2.39-3.18a7.47,7.47,0,0,1,2.07-.46,3.18,3.18,0,0,1,1.56.25C3298.9,190.85,3299.74,192.17,3299.4,193.11Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3304.77,199.19c-.77,1.09-1.78,1.68-2.5,1.51a.89.89,0,0,1-.44-.23c-.67-.65-.45-2.26.49-3.61a5.14,5.14,0,0,1,2.75-1.65c.33-.1.54-.14.54-.14S3305.72,197.83,3304.77,199.19Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3299.87,200.42a1.42,1.42,0,0,1-1.57.67,3.59,3.59,0,0,1-1.56-.59c-1.31-.84-2.1-3.46-2.1-3.46a8.38,8.38,0,0,1,1.4-.21h.05a3.78,3.78,0,0,1,2.17.45C3299.57,198.12,3300.29,199.53,3299.87,200.42Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3299.84,181.9c-.28,1.48-1.12,2.53-1.87,2.34l-.08,0c-.69-.27-1-1.58-.75-3a5.78,5.78,0,0,1,1.59-2.54l.39-.36A7.33,7.33,0,0,1,3299.84,181.9Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3297.46,186.21c-.15.74-1,1.16-2,1.07a3.21,3.21,0,0,1-.58-.1c-1.28-.34-2.48-2.31-2.48-2.31a6.2,6.2,0,0,1,2.32-.88,2.21,2.21,0,0,1,.77,0C3296.72,184.37,3297.62,185.35,3297.46,186.21Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3295.76,176.1c-.07,1.33-.67,2.36-1.33,2.31a.68.68,0,0,1-.23-.07c-.54-.25-.9-1.25-.83-2.42a5,5,0,0,1,1.05-2.4,4.44,4.44,0,0,1,.31-.39A6.15,6.15,0,0,1,3295.76,176.1Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3294.49,180.5c0,.78-1,1.33-2.13,1.25h-.05a4.8,4.8,0,0,1-2.34-1.58,5.29,5.29,0,0,1,2.17-1.19,1.53,1.53,0,0,1,.37,0C3293.65,179,3294.54,179.73,3294.49,180.5Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3292.26,176.5a1.08,1.08,0,0,1-1.22.46,2.74,2.74,0,0,1-1.16-.49,5.81,5.81,0,0,1-1.52-2.68,5.59,5.59,0,0,1,.86-.1,3.07,3.07,0,0,1,1.89.38C3292.09,174.75,3292.6,175.84,3292.26,176.5Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3302.79,212.85s-1,2.51-2.38,3.19a3.87,3.87,0,0,1-1.32.39h0a1.4,1.4,0,0,1-1.25-.84c-.34-.94.49-2.26,1.87-2.94a2.74,2.74,0,0,1,1-.25A7.53,7.53,0,0,1,3302.79,212.85Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3295.45,215a.87.87,0,0,1-.36.18,3.55,3.55,0,0,1-2-1.68,8,8,0,0,1-.62-4,5.34,5.34,0,0,1,2.65,1.86C3296,212.74,3296.16,214.37,3295.45,215Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3299.07,219.44s-1.37,2.26-2.82,2.66a3.18,3.18,0,0,1-.72.12,1.73,1.73,0,0,1-1.73-1.21c-.21-1,.82-2.11,2.27-2.5a2,2,0,0,1,.34-.06A7,7,0,0,1,3299.07,219.44Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3291,220.29a3.43,3.43,0,0,1-1.66-2.64,7.56,7.56,0,0,1,.65-3.77,6.52,6.52,0,0,1,1.89,2.93C3292.15,218.48,3291.77,220,3291,220.29Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3305.56,204.28s-.61,2.67-1.85,3.63a3.74,3.74,0,0,1-1.71.77,1.16,1.16,0,0,1-.88-.57c-.48-.85.14-2.32,1.39-3.28a3.89,3.89,0,0,1,2.15-.63h0A6,6,0,0,1,3305.56,204.28Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3299.09,208.05a1.11,1.11,0,0,1-.81.5,3.52,3.52,0,0,1-1.77-.85c-1.21-1-1.73-3.72-1.73-3.72l.46,0h.09a4.19,4.19,0,0,1,2.48.76C3299,205.72,3299.59,207.22,3299.09,208.05Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3302.5,190.19a3.49,3.49,0,0,1-1.84,2.24h0l-.12-.05c-.81-.4-1-2-.41-3.62a6,6,0,0,1,2.27-2.5A7.92,7.92,0,0,1,3302.5,190.19Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3298.85,193.11a1.36,1.36,0,0,1-1.23.84,3.74,3.74,0,0,1-1.33-.38c-1.37-.68-2.39-3.18-2.39-3.18a7.47,7.47,0,0,1,2.07-.46,2.68,2.68,0,0,1,1,.25C3298.36,190.85,3299.2,192.17,3298.85,193.11Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3304.23,199.19a3.53,3.53,0,0,1-2,1.51.89.89,0,0,1-.44-.23c-.67-.65-.45-2.26.49-3.61a5.14,5.14,0,0,1,2.75-1.65A8,8,0,0,1,3304.23,199.19Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3299.33,200.42a1.27,1.27,0,0,1-1,.67,3.59,3.59,0,0,1-1.56-.59c-1.31-.84-2.1-3.46-2.1-3.46a8.38,8.38,0,0,1,1.4-.21h.05a3.3,3.3,0,0,1,1.63.45C3299,198.12,3299.75,199.53,3299.33,200.42Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3299.3,181.9a3.06,3.06,0,0,1-1.41,2.31c-.69-.27-1-1.58-.75-3a5.78,5.78,0,0,1,1.59-2.54A6.43,6.43,0,0,1,3299.3,181.9Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3296.91,186.21a1.52,1.52,0,0,1-1.49,1.07,3.21,3.21,0,0,1-.58-.1c-1.28-.34-2.48-2.31-2.48-2.31a6.2,6.2,0,0,1,2.32-.88l.22,0C3296.18,184.37,3297.08,185.35,3296.91,186.21Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3295.22,176.1a2.62,2.62,0,0,1-1,2.24c-.54-.25-.9-1.25-.83-2.42a5,5,0,0,1,1.05-2.4A5.39,5.39,0,0,1,3295.22,176.1Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3293.94,180.5c0,.66-.73,1.16-1.63,1.24a4.8,4.8,0,0,1-2.34-1.58,5.29,5.29,0,0,1,2.17-1.19C3293.19,179.11,3294,179.77,3293.94,180.5Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3291.72,176.5a.93.93,0,0,1-.68.46,2.74,2.74,0,0,1-1.16-.49,5.81,5.81,0,0,1-1.52-2.68,5.59,5.59,0,0,1,.86-.1,2.55,2.55,0,0,1,1.34.38C3291.54,174.75,3292.05,175.84,3291.72,176.5Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3250.83,215.1c-.34,1-1.73,1.2-3.11.48l-.16-.09c-1.29-.82-2.23-3.25-2.23-3.25a5.63,5.63,0,0,1,3.39-.31,1.22,1.22,0,0,1,.24.1C3250.34,212.75,3251.18,214.12,3250.83,215.1Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3255.55,212.87c-.87,1.49-2.15,2.19-2.86,1.58l-.05-.06c-.66-.67-.51-2.32.33-3.76a5.39,5.39,0,0,1,2.68-2,4.79,4.79,0,0,1,.51-.17S3256.42,211.38,3255.55,212.87Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3254.89,220.8c-.2,1-1.54,1.55-3,1.14a2.45,2.45,0,0,1-.65-.32,8.56,8.56,0,0,1-2.17-2.47s2.09-1.39,3.54-1c.16,0,.29.1.44.15C3254.26,218.82,3255.07,219.87,3254.89,220.8Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3259.4,217.27c-.35,1.78-1.31,3-2.16,2.78a.88.88,0,0,1-.39-.23,4.12,4.12,0,0,1-.54-3.43,7,7,0,0,1,2-3.15l.32-.3A9.16,9.16,0,0,1,3259.4,217.27Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3247.55,207.26c-.41.78-1.53.81-2.64.14h0a3.43,3.43,0,0,1-.48-.33c-1.24-1-1.85-3.81-1.85-3.81a6.32,6.32,0,0,1,2.88.19,2.55,2.55,0,0,1,.72.4C3247.4,204.84,3248,206.37,3247.55,207.26Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3253.9,202.94s-.52,2.83-1.74,3.9c-1.06.93-2.28,1.17-2.9.62a.92.92,0,0,1-.22-.26c-.51-.87.06-2.43,1.28-3.51a4.55,4.55,0,0,1,3-.78A5,5,0,0,1,3253.9,202.94Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3248.14,190.77a1.06,1.06,0,0,1-1.15-.21,4.39,4.39,0,0,1-1.37-2.08,9.17,9.17,0,0,1,.16-4.37.15.15,0,0,0,0-.06,6.83,6.83,0,0,1,2.74,2.92C3249.12,188.65,3248.94,190.35,3248.14,190.77Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3254.78,188.68s-1,2.62-2.4,3.33a2.56,2.56,0,0,1-2.71.08,1.21,1.21,0,0,1-.4-.56c-.34-1,.5-2.36,1.88-3.07a4.39,4.39,0,0,1,3.06,0C3254.56,188.59,3254.78,188.68,3254.78,188.68Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3246.83,199.25c-.41.4-1,.35-1.68-.07a4.23,4.23,0,0,1-1.26-1.27c-.95-1.42-.84-4.31-.84-4.31a7.35,7.35,0,0,1,1.5.49,4.23,4.23,0,0,1,1.79,1.38C3247.29,196.88,3247.51,198.58,3246.83,199.25Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3254,195.67s-.78,2.73-2.09,3.61a2.47,2.47,0,0,1-2.81.33,1,1,0,0,1-.33-.41c-.42-.93.3-2.41,1.61-3.29a4.5,4.5,0,0,1,3.05-.37A4.68,4.68,0,0,1,3254,195.67Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3250.7,182.23a.85.85,0,0,1-.81-.25,3.88,3.88,0,0,1-1.06-2.2,7.53,7.53,0,0,1,.64-3.6l.08-.18a6.63,6.63,0,0,1,2,3C3251.82,180.59,3251.45,182,3250.7,182.23Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3256.33,182.9s-1.21,2.06-2.49,2.42a2.54,2.54,0,0,1-2.13-.25,1.21,1.21,0,0,1-.49-.77c-.17-.9.73-1.93,2-2.28a3.42,3.42,0,0,1,2.12.34A6.17,6.17,0,0,1,3256.33,182.9Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3254.24,176.12a.72.72,0,0,1-.59-.27,3.48,3.48,0,0,1-.73-2.15,6,6,0,0,1,.89-2.86l.15-.26a6.21,6.21,0,0,1,1.35,2.93C3255.39,174.9,3254.91,176.07,3254.24,176.12Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3258.72,178s-1.26,1.57-2.4,1.66a2.37,2.37,0,0,1-1.58-.39,1.22,1.22,0,0,1-.55-.92c0-.81.84-1.53,2-1.62a2.07,2.07,0,0,1,.89.17A6,6,0,0,1,3258.72,178Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3260.33,171.27a6.24,6.24,0,0,1-1.52,2.82c-.85.61-1.77.71-2.22.25a.79.79,0,0,1-.16-.23c-.35-.69.17-1.83,1.15-2.54a3.25,3.25,0,0,1,2.16-.39A4.15,4.15,0,0,1,3260.33,171.27Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3250.3,214.84c-.31.89-1.5,1.15-2.74.65-1.29-.82-2.23-3.25-2.23-3.25a5.63,5.63,0,0,1,3.39-.31C3249.92,212.67,3250.62,213.93,3250.3,214.84Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3255,212.6c-.7,1.2-1.67,1.89-2.38,1.79-.66-.67-.51-2.32.33-3.76a5.39,5.39,0,0,1,2.68-2A8.33,8.33,0,0,1,3255,212.6Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3254.35,220.54c-.19,1-1.54,1.54-3,1.13l-.13,0a8.56,8.56,0,0,1-2.17-2.47s2.09-1.39,3.54-1c.16,0,.29.1.44.15A2.31,2.31,0,0,1,3254.35,220.54Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3258.86,217c-.31,1.68-1.19,2.89-2,2.82a4.12,4.12,0,0,1-.54-3.43,7,7,0,0,1,2-3.15A7.8,7.8,0,0,1,3258.86,217Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3247,207c-.35.65-1.19.78-2.11.4h0a3.43,3.43,0,0,1-.48-.33c-1.24-1-1.85-3.81-1.85-3.81a6.32,6.32,0,0,1,2.88.19l.18.13C3246.88,204.57,3247.5,206.1,3247,207Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3253.32,202.91c-.16.69-.68,2.78-1.68,3.66a3,3,0,0,1-2.38.89.92.92,0,0,1-.22-.26c-.51-.87.06-2.43,1.28-3.51A4.55,4.55,0,0,1,3253.32,202.91Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3247.6,190.5a.81.81,0,0,1-.61.06,4.39,4.39,0,0,1-1.37-2.08,9.17,9.17,0,0,1,.16-4.37,6,6,0,0,1,2.22,2.59C3248.59,188.38,3248.41,190.08,3247.6,190.5Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3254.21,188.49c-.18.44-1.12,2.62-2.36,3.26a3.06,3.06,0,0,1-2.18.34,1.21,1.21,0,0,1-.4-.56c-.34-1,.5-2.36,1.88-3.07A4.39,4.39,0,0,1,3254.21,188.49Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3246.3,199a1.07,1.07,0,0,1-1.15.19,4.23,4.23,0,0,1-1.26-1.27c-.95-1.42-.84-4.31-.84-4.31a7.35,7.35,0,0,1,1.5.49,3.84,3.84,0,0,1,1.26,1.11C3246.76,196.62,3247,198.31,3246.3,199Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3253.46,195.54c-.18.58-.92,2.71-2.05,3.48a3,3,0,0,1-2.28.59,1,1,0,0,1-.33-.41c-.42-.93.3-2.41,1.61-3.29A4.5,4.5,0,0,1,3253.46,195.54Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3250.17,182a.66.66,0,0,1-.28,0,3.88,3.88,0,0,1-1.06-2.2,7.53,7.53,0,0,1,.64-3.6,5.81,5.81,0,0,1,1.53,2.58C3251.29,180.32,3250.92,181.76,3250.17,182Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3255.8,182.64s-1.21,2.06-2.49,2.41a3,3,0,0,1-1.6,0,1.21,1.21,0,0,1-.49-.77c-.17-.9.73-1.93,2-2.28a3.42,3.42,0,0,1,2.12.34C3255.63,182.52,3255.8,182.64,3255.8,182.64Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3253.72,175.85h-.07a3.48,3.48,0,0,1-.73-2.15,6,6,0,0,1,.89-2.86,5.24,5.24,0,0,1,1,2.41C3254.85,174.63,3254.38,175.8,3253.72,175.85Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3258.19,177.69s-1.27,1.57-2.4,1.66a2.56,2.56,0,0,1-1.05-.12,1.22,1.22,0,0,1-.55-.92c0-.81.84-1.53,2-1.62a2.07,2.07,0,0,1,.89.17A6.29,6.29,0,0,1,3258.19,177.69Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3259.74,171.18a5.59,5.59,0,0,1-1.46,2.64,2.4,2.4,0,0,1-1.69.52.79.79,0,0,1-.16-.23c-.35-.69.17-1.83,1.15-2.54A3.25,3.25,0,0,1,3259.74,171.18Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M3310,197.46A35.56,35.56,0,0,1,3274.42,233c-1,0-1.92,0-2.87-.11a35.62,35.62,0,0,1-29.74-21.32c52.71,12.3,49.65-36.08,48.72-44.66a5.27,5.27,0,0,0,.22-1,34.5,34.5,0,0,1,14.9,14.63A35.25,35.25,0,0,1,3310,197.46Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M3310,197.46A35.56,35.56,0,0,1,3274.42,233c-1,0-1.92,0-2.87-.11,24.09-8.35,31.39-34,33.6-48.52l1.62-1.55A33.15,33.15,0,0,1,3310,197.46Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "78.09 157.64 70.68 156.85 70.12 159.82 65.48 155.18 61.21 150.91 47.81 137.5 27.73 117.42 25.91 115.61 17.76 107.45 15.88 105.59 14 103.69 13.04 102.73 12.81 102.51 13.96 102.27 12.76 92.78 13.08 92.65 21.94 101.51 23.85 103.41 23.85 103.42 25.11 104.68 30.52 110.1 30.57 110.14 30.6 110.15 30.66 110.23 53.86 133.42 66.04 145.59 66.26 145.81 66.73 146.28 68.16 147.71 68.16 147.72 69.97 149.52 69.98 149.53 71.16 150.72 78.09 157.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "80.41 155.23 79.91 154.73 76.25 151.08 74.45 149.28 74.44 149.26 73.45 148.27 73.09 147.93 73.09 147.91 72.8 147.62 70.97 145.8 68.04 142.87 56.22 131.05 31.69 106.52 29.46 104.29 28.6 103.42 28.26 103.09 20.74 95.57 18.08 92.9 17.67 92.5 19.99 92.74 22.73 93.03 22.99 91.72 68.58 137.31 70.23 138.96 70.39 139.12 72.53 141.26 74.64 143.38 74.81 143.54 76.06 144.79 77.25 145.98 77.32 146.05 79.52 148.25 80.41 155.23"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3286.64,222.43l-2.08-44.08-9.42.13q1.16,12.51.94,16a4.91,4.91,0,0,1-1.1,2.92,2.86,2.86,0,0,1-2.12,1.31q-2,0-2.42-4.16a198.1,198.1,0,0,1-.53-20.37l-10.29.74q-.2,2.9-.2,6.45a67,67,0,0,0,1.88,17.41q2.63,10.08,8.81,10.08,3.09,0,7-2.62l-1.08,18.15Z",
    transform: "translate(-3225.65 -72.7)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "59.68 122.15 58.9 105.65 54.44 105.65 58.11 106.66 60.06 130.12 59.68 122.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3272.86,198.71s-2.91,4.18-3.64-10.35-1.06-12.51-1.06-12.51l-8.54-.93,10.29-.74a198.1,198.1,0,0,0,.53,20.37Q3270.85,198.71,3272.86,198.71Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "29.98 0 50.06 85.73 52.97 85.73 35.19 0 29.98 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "23.95 0 46.23 85.73 50.06 85.73 29.98 0 23.95 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "18.34 0 43.58 85.73 46.23 85.73 23.95 0 18.34 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "18.34 0 43.58 85.73 46.23 85.73 23.95 0 18.34 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M3266.87,160.26a17.56,17.56,0,0,1,.36-2.66c.16-.77.38-.39.7-.16s.49.26.81-.2a4.57,4.57,0,0,1,.6-.76,4.63,4.63,0,0,1,3.47-1.37,4.89,4.89,0,0,1,2.13.44,4.43,4.43,0,0,1,.7.41l.22.17c.13.09,2.74,2.3,2.84,4a25.29,25.29,0,0,1,3.53,1c0-.14.05-.32.07-.56a12.88,12.88,0,0,0-1.52-5h0s0,0,0,0a6.71,6.71,0,0,0-.53-.87s0,0,0-.06a7.27,7.27,0,0,0-6.29-3c-2.37,0-5.51.81-7.08,2.43-2.88,3-3.38,5-3.46,6.51.94-.07,1.87-.11,2.81-.16Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3278.7,160.09q1.07.22,2.07.54c.14-2-2.39-3-3.35-4.51l-.46-.46a3.82,3.82,0,0,0-2-.11,4.16,4.16,0,0,1,.92.57C3276,156.23,3278.59,158.43,3278.7,160.09Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3266.11,160.44l1.11-2.83.71-.17.8-.2.69-1.74,1-.13,6.63-.9a38.28,38.28,0,0,0,3.77,1.1h0a0,0,0,0,0,0,0,6.75,6.75,0,0,0-.54-.92,5.91,5.91,0,0,0-.94-1.09,7.71,7.71,0,0,0-5.35-1.87,13,13,0,0,0-4.41.81,7.53,7.53,0,0,0-2.67,1.63c-2.88,3-3.38,5-3.46,6.51C3264.3,160.53,3265.21,160.48,3266.11,160.44Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3268.56,159.89a5.9,5.9,0,0,1,1.56-1.95c.21-.21.44-.43.69-.7a4.59,4.59,0,0,1,3.46-1.38,7.42,7.42,0,0,1,1.37.1,3.44,3.44,0,0,1,2.12,1,14.78,14.78,0,0,1,1.15,1.29,5.79,5.79,0,0,1,1.13,2.14,25,25,0,0,1,2.84,1c.26,0,.52.09.78.15a8.53,8.53,0,0,0-1.79-5,16.33,16.33,0,0,0-1.64-1.95,7.81,7.81,0,0,0-6-2.2,8.39,8.39,0,0,0-3.66.78h0a8,8,0,0,0-2.27,1.65,11.48,11.48,0,0,0-3.34,5.66l1.21-.06C3267,160.22,3267.77,160,3268.56,159.89Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3281.87,156.56l-3,1.72a14.78,14.78,0,0,0-1.15-1.29,3.44,3.44,0,0,0-2.12-1,7.42,7.42,0,0,0-1.37-.1,4.59,4.59,0,0,0-3.46,1.38c-.25.27-.48.49-.69.7l.26-2.57.22-2.18h0a7.35,7.35,0,0,0-1.08-.73,13,13,0,0,1,4.41-.81,7.71,7.71,0,0,1,5.35,1.87c.3.37.6.73.94,1.09A16.33,16.33,0,0,1,3281.87,156.56Z",
    transform: "translate(-3225.65 -72.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "61.76 0 43.98 85.73 46.89 85.73 66.98 0 61.76 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "66.98 0 46.89 85.73 50.72 85.73 73 0 66.98 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "73 0 50.72 85.73 52.35 85.73 78.26 0 73 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "73 0 50.72 85.73 52.35 85.73 78.26 0 73 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.8ee14bde358c45f96d5e92ec08872007.svg";
export { ForwardRef as ReactComponent };